<template>
  <div :class="divConentClass">
    <img
      height="80"
      class="rounded"
      :src="demoImageUrl"
      :alt="therapistName"
      v-if="showPicture"
    />
    <div class="text-center" :class="isMobile ? 'px-1' : ''">
      <span
        :style="isMobile ? 'font-size:0.7em;font-weight:bold' : ''"
        :class="tharpistNameClass"
        v-if="withIcon"
        >{{ therapistName }}</span
      >
      <therapist-pschology-organication-link
        :showPsychologyOrganizationLink="showPsychologyOrganizationLink"
        :psychologyOrganizationLink="psychologyOrganizationLink"
        v-if="withIcon"
      ></therapist-pschology-organication-link>
    </div>

    <a
      v-if="!withIcon"
      class="dropdown-toggle"
      :class="
        showPsychologyOrganizationLink
          ? 'border-2 border-bottom border-secondary'
          : ''
      "
      href="#"
      role="button"
      id="exClickable"
      :data-bs-toggle="showPsychologyOrganizationLink ? 'dropdown' : ''"
      data-bs-auto-close="outside"
      aria-expanded="false"
    >
      <span
        :style="isMobile ? 'font-size:0.7em;font-weight:bold' : ''"
        :class="tharpistNameClass"
        >{{ therapistName }}</span
      >
    </a>

    <div
      class="dropdown-menu p-4"
      style="width: 350px"
      aria-labelledby="dropdownMenuLink"
      ref="profileMenu"
    >
      <div class="text-end clearfix p-0 m-0">
        <button
          type="button"
          class="modal-header btn-close mt-0 mb-2 pointer float-end"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="closeButtonClick"
        ></button>
      </div>

      <p class="small justified">
        شما می توانید از لینک زیر به منظور مشاهده پروفایل درمانگر در سایت رسمی
        سازمان نظام روانشناسی و مشاوره کشور استفاده نمایید.
      </p>
      <a
        :href="psychologyOrganizationLink"
        target="_blank"
        class="btn w-100 btn-sm rounded btn-blueSite"
      >
        <svg
          width="18px"
          height="18px"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-person-bounding-box ms-2"
          viewBox="0 0 16 16"
        >
          <path
            d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5z"
          ></path>
          <path
            d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"
          ></path>
        </svg>
        نمایش پروفایل درمانگر
      </a>
    </div>
  </div>
</template>
<script>
// import axios from 'axios';
import TherapistPschologyOrganicationLink from '../therapistPschologyOrganicationLink/TherapistPschologyOrganicationLink.vue';
import { isMobile } from 'mobile-device-detect';

export default {
  components: { TherapistPschologyOrganicationLink },
  props: {
    showPicture: {
      type: Boolean,
      required: false,
      default: true,
    },
    showPsychologyOrganizationLink: {
      type: Boolean,
      required: false,
      default: true,
    },
    ID: {
      type: Number,
      required: true,
      default: null,
    },
    psychologyOrganizationLink: {
      type: String,
      required: false,
      default: null,
    },
    therapistName: {
      type: String,
      required: true,
      default: null,
    },
    divConentClass: {
      type: String,
      required: false,
      default: null,
    },
    tharpistNameClass: {
      type: String,
      required: false,
      default: null,
    },
    withIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      isMobile: isMobile,
      demoImageUrl: '/img/No_Avatar.png',
    };
  },
  methods: {
    async getProfilePicture() {
      return;
      // let that = this;
      // await axios
      //   .get(`/FS/ProfilePicture/GetProfilePicture/${this.ID}`, {
      //     responseType: 'blob',
      //   })
      //   .then((response) => {
      //     if (response.data && response.data.size > 0) {
      //       that.demoImageUrl = URL.createObjectURL(response.data);
      //     }
      //   })
      //   .finally(() => {});
    },
    closeButtonClick() {
      if (this.$refs.profileMenu) {
        this.$refs.profileMenu.classList.toggle('show');
      }
    },
  },
  async mounted() {
    if (this.ID) {
      await this.getProfilePicture(this.ID);
    }
  },
};
</script>
